var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    fill: "#ffffff",
    stroke: "#ffffff",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "arrow-right-circle"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch Beta."), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-308 -1087)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m324 1117c-7.732 0-14-6.27-14-14s6.268-14 14-14 14 6.27 14 14-6.268 14-14 14zm0-30c-8.837 0-16 7.16-16 16s7.163 16 16 16 16-7.16 16-16-7.163-16-16-16zm6.535 15.12-5.656-5.66c-0.391-0.39-1.024-0.39-1.414 0-0.391 0.4-0.391 1.03 0 1.42l4.121 4.12h-10.586c-0.553 0-1 0.45-1 1s0.447 1 1 1h10.586l-4.121 4.12c-0.391 0.39-0.391 1.03 0 1.42 0.39 0.39 1.023 0.39 1.414 0l5.656-5.66c0.24-0.24 0.315-0.57 0.26-0.88 0.055-0.31-0.02-0.64-0.26-0.88z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.bcdadbec348fe1a5bafedb8b4e1af5a0.svg";
export { ForwardRef as ReactComponent };